import { useState } from "react";
import { api } from "api";

const ENDPOINT = "prod_bodega_reajustes_inventario";

export const ReajustePacasApi = () => {
    const [cargando, setCargando] = useState(false);

    // Pallets con existencia de la fila del cierre, con el reajuste que ya
    // tengan registrado. Con `sinMascara` no se levanta la máscara de carga: su
    // overlay cubre los botones del formulario, y si aparece mientras se hace
    // clic en uno se pierde el clic
    const getLineasPacas = async (fila, sinMascara = false) => {
        try {
            if (!sinMascara) setCargando(true);

            const response = await api.get(`${ENDPOINT}/pacas`, fila);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            if (!sinMascara) setCargando(false);
        }
    };

    // no toca `cargando`: se dispara al salir de cada campo de la tabla
    const guardarReajustePallet = async (data) => {
        try {
            const response = await api.post(ENDPOINT, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const eliminarReajustePallet = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`${ENDPOINT}/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getLineasPacas,
        guardarReajustePallet,
        eliminarReajustePallet,

        cargando,
    };
};
